"use client";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import type { ReactNode } from "react";

const pk = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY;
const stripePromise = pk ? loadStripe(pk) : null;

const ELEMENT_STYLE = {
  base: {
    color: "#e4e4e7",
    fontFamily: '"Geist", ui-sans-serif, system-ui, -apple-system, sans-serif',
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    "::placeholder": { color: "rgba(255,255,255,0.2)" },
    iconColor: "rgba(255,255,255,0.4)",
  },
  invalid: { color: "#e97375", iconColor: "#e97375" },
  complete: { iconColor: "#42BA82" },
};

export { ELEMENT_STYLE };

interface Props {
  amount?: number;
  children: ReactNode;
}

export function StripeElementsProvider({ amount, children }: Props) {
  // Always mount <Elements> so descendants can call useStripe()/useElements()
  // without crashing. When the publishable key is missing, stripePromise is
  // null — Stripe treats this as a "still loading" state (the context exists,
  // useStripe() returns null), and consumers guard on `!!stripe` accordingly.
  return (
    <Elements
      stripe={stripePromise}
      options={{
        mode: "subscription" as const,
        amount: Math.max(amount ?? 100, 100),
        currency: "usd",
        paymentMethodTypes: ["card", "link"],
        fonts: [
          {
            cssSrc: "https://fonts.googleapis.com/css2?family=Geist:wght@400;500;600&display=swap",
          },
        ],
      }}
    >
      {children}
    </Elements>
  );
}
